export default "__VITE_ASSET__241d7afb__"